import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { FiStateNames } from '@fi-app/shared/fi-state-proxy/fi-state-names';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { DomSanitizer } from '@angular/platform-browser';

enum GuideCardDescriptionLinks {
    Quizzes = 'quizzes',
    ToDoLists = 'todoList',
    Pages = 'pages',
    Files = 'files',
    OnboardingBuilder = 'onboardingBuilder',
}

@Component({
    selector: 'fi-onboarding-guide',
    templateUrl: './fi-onboarding-guide.component.html',
    styleUrl: './fi-onboarding-guide.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-onboarding-guide' },
    standalone: false,
})
export class FiOnboardingGuideComponent {
    private fiStateService = inject(FiStateService);
    protected sanitizer = inject(DomSanitizer);

    private readonly navLabelToStateNameMap = {
        [GuideCardDescriptionLinks.Quizzes]: FiStateNames.Onboarding.Quiz.List,
        [GuideCardDescriptionLinks.ToDoLists]: FiStateNames.Onboarding.Todo.List,
        [GuideCardDescriptionLinks.Pages]: FiStateNames.Document.List,
        [GuideCardDescriptionLinks.Files]: FiStateNames.MediaBank.List,
        [GuideCardDescriptionLinks.OnboardingBuilder]: FiStateNames.Onboarding.List,
    };

    protected handleGuideCardDescriptionClick($event: MouseEvent): void {
        if ($event.target instanceof HTMLElement) {
            const navLabel = $event.target.getAttribute('data-nav-label');
            if (!navLabel) {
                return;
            }
            const stateName = this.navLabelToStateNameMap[navLabel as GuideCardDescriptionLinks];
            if (!stateName) {
                return;
            }
            this.fiStateService.go(stateName);
        }
    }
}
